<div class="game-container">
  <h2>No Result Found. Please refresh</h2>
  <p *ngIf="!gameRunning && !gameOver" class="instruction">
    Click the canvas or press SPACE to start the game!
  </p>
  <canvas
    id="gameCanvas"
    width="800"
    height="300"
    (click)="onCanvasClick()">
  </canvas>
  <div class="controls">
    <p>🎮 Use SPACEBAR or CLICK to jump and avoid obstacles</p>
  </div>
</div>
